<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-card-title class="body-1">
        {{ userData.Id > 0 ? 'Edit registrant' : 'Add/invite registrant' }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <v-col v-if="isGlobalAdmin" cols="12">
                <v-text-field
                  v-model.number="userData.ClientId"
                  label="Client Id"
                  hide-details
                  outlined
                  type="number"
                  :disabled="userData.Status === 'APPROVED'"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Name"
                  :label="$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.USER_NAME')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Email"
                  :label="$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-if="campaign.Type == 'DISCOUNT_PERCENT'"
                  v-model="userData.DiscountPercent"
                  :label="'Discount %'"
                  :placeholder="'Discount %'"
                  outlined
                  hide-details
                  type="number"
                  :suffix="campaign.DiscountCreditCurrency"
                />
                <v-text-field
                  v-if="campaign.Type == 'DISCOUNT_CREDIT'"
                  v-model="discountCredit"
                  :label="'Discount credit'"
                  :placeholder="'Discount credit'"
                  outlined
                  hide-details
                  type="number"
                  :suffix="campaign.DiscountCreditCurrency"
                />
                <v-text-field
                  v-if="campaign.Type == 'PREPAID_CREDIT'"
                  v-model="discountCredit"
                  :label="'Peapaid credit'"
                  :placeholder="'Prepaid credit'"
                  outlined
                  hide-details
                  type="number"
                  :suffix="campaign.DiscountCreditCurrency"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-if="campaign.Type == 'DISCOUNT_CREDIT'"
                  v-model="usedDiscountCredit"
                  :label="'Used discount credit'"
                  :placeholder="'Used discount credit'"
                  outlined
                  hide-details
                  type="number"
                  :suffix="campaign.DiscountCreditCurrency"
                />
                <v-text-field
                  v-if="campaign.Type == 'PREPAID_CREDIT'"
                  v-model="usedDiscountCredit"
                  :label="'Used prepaid credit'"
                  :placeholder="'Used prepaid credit'"
                  outlined
                  hide-details
                  type="number"
                  :suffix="campaign.DiscountCreditCurrency"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.CarNumber"
                  :label="$vuetify.lang.t('$vuetify.CAR_NUMBER')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <!-- <v-text-field
                  v-model="userData.PhoneNumber"
                  :label="
                    $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PHONE_NUMBER')
                  "
                  hide-details
                  outlined
                  required
                  :disabled="userData.Status === 'APPROVED'"
                ></v-text-field> -->
                <phone-select
                  :initial-country-code="
                    userData && userData.Region !== ''
                      ? userData.Region
                      : whitelist.Region
                  "
                  :initial-phone-number="userData.PhoneNumber"
                />
              </v-col>
              <!-- <v-col cols="12">
                <v-combobox
                  v-model="userData.Vehicles"
                  :label="
                    $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.CAR_NUMBERS')
                  "
                  multiple
                  outlined
                  :return-object="false"
                  item-text="PlateNumber"
                  hide-details
                  small-chips
                  deletable-chips
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Press <kbd>enter</kbd> to add
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col> -->
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="validFromPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="
                        userData.ValidFrom !== '0001-01-01T00:00:00Z' &&
                        userData.ValidFrom !== '0001-01-01' &&
                        userData.ValidFrom !== null
                          ? new Date(userData.ValidFrom)
                              .toISOString()
                              .substr(0, 10)
                          : ''
                      "
                      :label="$vuetify.lang.t('$vuetify.VALID_FROM')"
                      :placeholder="$vuetify.lang.t('$vuetify.VALID_FROM')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      clearable
                      v-bind="attrs"
                      @click:clear="userData.ValidFrom = null"
                      @click:append="validFromPicker = !validFromPicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :value="
                      userData.ValidFrom !== '0001-01-01T00:00:00Z' &&
                      userData.ValidFrom !== '0001-01-01' &&
                      userData.ValidFrom !== null
                        ? new Date(userData.ValidFrom)
                            .toISOString()
                            .substr(0, 10)
                        : ''
                    "
                    @change="
                      userData.ValidFrom = new Date($event).toISOString()
                    "
                    @input="validFromPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="validToPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="
                        userData.ValidTo !== '0001-01-01T00:00:00Z' &&
                        userData.ValidTo !== '0001-01-01' &&
                        userData.ValidTo !== null
                          ? new Date(userData.ValidTo)
                              .toISOString()
                              .substr(0, 10)
                          : ''
                      "
                      :label="$vuetify.lang.t('$vuetify.VALID_TO')"
                      :placeholder="$vuetify.lang.t('$vuetify.VALID_TO')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      clearable
                      v-bind="attrs"
                      @click:clear="userData.ValidTo = null"
                      @click:append="validToPicker = !validToPicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :value="
                      userData.ValidTo !== '0001-01-01T00:00:00Z' &&
                      userData.ValidTo !== '0001-01-01' &&
                      userData.ValidTo !== null
                        ? new Date(userData.ValidTo).toISOString().substr(0, 10)
                        : ''
                    "
                    @change="userData.ValidTo = new Date($event).toISOString()"
                    @input="validToPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="userData.Comment"
                  :label="$vuetify.lang.t('$vuetify.COMMENTS')"
                  hide-details
                  outlined
                  height="100"
                ></v-textarea>
              </v-col>
              <!-- <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="userData.StartSessionsWithLPR"
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.EDIT_WHITELISTS.START_SESSIONS_WITH_LPR'
                    )
                  "
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="userData.IsNewRenter"
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.EDIT_WHITELISTS.CHARGE_FOR_SESSIONS'
                    )
                  "
                  hide-details
                ></v-checkbox>
              </v-col> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="secondary--text"
          :disabled="!formValid"
          @click="updateWhitelistUser()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import WhitelistUser from '@/models/whitelist-user'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'EditCampaignRegistrantDialog',
  components: {
    PhoneSelect: () =>
      import(
        /* webpackChunkName: "PhoneSelect" */ '@/components/commonComponents/PhoneSelect'
      )
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    selectedUser: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Add user'
    }
  },
  data() {
    return {
      formValid: true,
      validFromPicker: false,
      validToPicker: false,
      userData: { ...this.selectedUser },
      privileges: [
        { id: 1, title: 'Superadmin' },
        { id: 2, title: 'Region/Zone admin' },
        { id: 3, title: 'None' }
      ],
      selectedPrivileges: null,
      confirmPassword: '',
      vehicles: '',
      isValidPhoneNumber: false
    }
  },
  created() {
    EventBus.$on('phoneNumberChanged', item => {
      this.userData.PhoneNumber = item.event
      this.isValidPhoneNumber = item.valid
    })
    EventBus.$on('phoneDiallingCodeChanged', item => {
      this.diallingCode = item.event.dialling_code
      this.isValidPhoneNumber = item.valid
    })
    if (this.inviting === true) {
      this.userData.RegistrationType = 'MANUALLY_INVITED'
    } else {
      this.userData.RegistrationType = 'MANUALLY_ADDED'
    }
  },
  computed: {
    ...mapGetters('app', ['loading', 'error', 'availableApplications']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('users', ['userRegions', 'userZones']),
    ...mapGetters('campaigns', ['campaign', 'inviting']),
    discountCredit: {
      get() {
        return this.userData.DiscountCreditInCents != null
          ? this.userData.DiscountCreditInCents / 100
          : null
      },
      set(value) {
        this.userData.DiscountCreditInCents =
          value === '' || value === null
            ? null
            : Math.round(Number(value) * 100)
      }
    },
    usedDiscountCredit: {
      get() {
        return this.userData.UsedDiscountCreditInCents != null
          ? this.userData.UsedDiscountCreditInCents / 100
          : null
      },
      set(value) {
        this.userData.UsedDiscountCreditInCents =
          value === '' || value === null
            ? null
            : Math.round(Number(value) * 100)
      }
    },
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.userData = new WhitelistUser().getObject()
          this.$emit('close')
        }
      }
    },
    licencePlates() {
      return this.userData.Vehicles.map(item => {
        return item.PlateNumber
      }).join(';')
    }
  },
  methods: {
    ...mapActions('whitelists', ['postWhitelistUser']),
    updateWhitelistUser() {
      if (this.userData.RegistrationType === 'MANUALLY_INVITED') {
        if (
          (!this.userData.PhoneNumber ||
            this.userData.PhoneNumber.trim().lenght === 0) &&
          (!this.userData.Email || this.userData.Email.trim().lenght === 0)
        ) {
          return this.errorAlert('Phone number or Email is required')
        }
      }
      if (
        this.userData.RegistrationType !== 'MANUALLY_INVITED' &&
        !this.isGlobalAdmin
      ) {
        if (
          (!this.userData.Vehicles || this.userData.Vehicles.length === 0) &&
          (!this.userData.Name || this.userData.Name.trim().length === 0)
        ) {
          return this.errorAlert('Name or licence plate(s) is required')
        }
      }
      if (this.userData.PhoneNumber && !this.isValidPhoneNumber) {
        return this.errorAlert('Invalid Phone number')
      }
      let temporaryArray = []
      if (
        Array.isArray(this.userData.Vehicles) &&
        typeof this.userData.Vehicles[0] === 'string'
      ) {
        this.userData.Vehicles.forEach(vehicle => {
          temporaryArray.push({
            PlateNumber: vehicle,
            WhitelistUserId: this.userData.ID
          })
        })
      } else {
        temporaryArray = this.userData.Vehicles
      }
      this.userData.Vehicles = temporaryArray
      if (this.diallingCode) {
        this.userData.PhoneNumber =
          this.diallingCode.replace('+', '') + this.userData.PhoneNumber
      }
      return this.$store
        .dispatch('campaigns/postRegistrant', {
          campaignId: this.campaign.ID,
          data: this.userData
        })
        .then(() => {
          if (!this.error) {
            this.show = false
          }
        })
    },
    errorAlert(message) {
      this.$store.commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message
        },
        { root: true }
      )
    }
  }
}
</script>
